import { ButtonDS } from "./ButtonDS"
import { IconButtonDS } from "./IconButtonDS"

export const components = { ButtonDS, IconButtonDS }
